<template>
  <div style="padding: 0 8px 20px">
    <el-space wrap :size="4">
      <div v-for="(item,index) in imgList" style="width: 230px; height: 230px">
        <el-image style="width: 230px; height: 230px" :src="item.img" fit="cover" @click="showImg(index, imgList)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </div>
    </el-space>
  </div>


</template>

<script>
import ImgViewer from "@/assets/js/imageViewer";

export default {
name: "imageList",
  props: {
    value: Object
  },
  data() {
    return {
      imgList: this.value.imgList
    }
  },
  methods: {
    showImg(idx, list) {
      let imgList = []
      for(let i=0; i< list.length; i++) {
        imgList.push(list[i].img)
      }
      ImgViewer.open({
        imgList,
        imgIndex: idx
      })
    },
  }
}
</script>

<style scoped>

</style>
